<template>
  <div id="app">
    <v-container>
      <Header />
      <v-dialog
        v-model="createCommsTemplateDialog"
        scrollable
        max-width="800px"
      >
        <v-form ref="formCreateTemplate">
          <v-card class="mx-auto" max-width="1000">
            <v-toolbar flat>
              <v-toolbar-title class="grey--text"
                >Comms Template</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-tabs v-model="tab" grow>
                <v-tab>Bookings</v-tab>
                <v-tab>Reminders</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card-text>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >contact_mail</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.name"
                      label="Template name"
                      :rules="[rules.required]"
                      filled
                    ></v-text-field>

                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.subject"
                      label="Email subject"
                      :rules="[rules.required]"
                      filled
                    ></v-text-field>

                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_name',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_fullname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_firstname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_surname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_details_table',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event details table</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_date',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_start_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_end_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_room_name',
                            'emailTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_blood_start_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Blood drop in start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_blood_end_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Blood drop in end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_urine_pot_location',
                            'emailTemplateTextArea'
                          )
                        "
                        >Urine pot location</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_link',
                            'emailTemplateTextArea'
                          )
                        "
                        >Link</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-textarea
                      id="emailTemplateTextArea"
                      v-model="templateForm.emailTemplate"
                      name="input-7-1"
                      class="ma-0 pa-0"
                      filled
                      label="Email template"
                      :rules="[rules.required]"
                      auto-grow
                    ></v-textarea>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_name',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_fullname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_firstname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_surname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_date',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_start_time',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_end_time',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_room_name',
                            'smsTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >sms</v-icon
                    >
                    <v-textarea
                      id="smsTemplateTextArea"
                      v-model="templateForm.smsTemplate"
                      name="input-7-1"
                      filled
                      label="SMS template"
                      counter="160"
                      :rules="[rules.required]"
                      auto-grow
                    ></v-textarea>
                    <v-file-input
                      multiple
                      label="Upload informed consent"
                      v-model="templateForm.attachment"
                    ></v-file-input>
                  </v-card-text>
                </v-tab-item>
                <v-tab-item>
                  <v-card-text>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.reminderEmailSubject"
                      label="Email reminder subject"
                      filled
                    ></v-text-field>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_name',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_fullname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_firstname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_surname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_details_table',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event details table</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_date',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_start_time',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_end_time',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_room_name',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_urine_pot_location',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Urine pot location</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_link',
                            'emailTemplateTextArea'
                          )
                        "
                        >Link</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-textarea
                      id="emailReminderTemplateTextArea"
                      v-model="templateForm.reminderEmailTemplate"
                      name="input-7-1"
                      class="ma-0 pa-0"
                      filled
                      label="Email reminder template"
                      auto-grow
                    ></v-textarea>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_name',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_fullname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_firstname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_surname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_date',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_start_time',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_end_time',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_room_name',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >sms</v-icon
                    >
                    <v-textarea
                      id="smsReminderTemplateTextArea"
                      v-model="templateForm.smsReminderTemplate"
                      name="input-7-1"
                      filled
                      label="SMS reminder template"
                      counter="160"
                      auto-grow
                    ></v-textarea>
                    <v-file-input
                      multiple
                      label="Upload document"
                      v-model="templateForm.reminderAttachment"
                    ></v-file-input>
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>

              <v-card-actions>
                <v-btn
                  color="info"
                  :right="true"
                  @click="createCommsTemplateDialog = false"
                  class="hp--btn"
                  >Close</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="createCommsTemplateLoader"
                  :right="true"
                  @click="createNewCommsTemplate"
                  class="hp--btn"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog
        v-model="updateCommsTemplateDialog"
        scrollable
        max-width="800px"
      >
        <v-form ref="formUpdateCreateTemplate">
          <v-card class="mx-auto" max-width="1000">
            <v-toolbar flat>
              <v-toolbar-title class="grey--text"
                >Edit comms template</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-tabs v-model="tab" grow>
                <v-tab>Bookings</v-tab>
                <v-tab>Reminders</v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card-text>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >contact_mail</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.name"
                      label="Template name"
                      :rules="[rules.required]"
                      filled
                    ></v-text-field>

                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.subject"
                      label="Email subject"
                      :rules="[rules.required]"
                      filled
                    ></v-text-field>

                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_name',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_fullname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_firstname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_surname',
                            'emailTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_details_table',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event details table</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_date',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_start_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_end_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_room_name',
                            'emailTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_blood_start_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Blood drop in start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_blood_end_time',
                            'emailTemplateTextArea'
                          )
                        "
                        >Blood drop in end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_urine_pot_location',
                            'emailTemplateTextArea'
                          )
                        "
                        >Urine pot location</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_link',
                            'emailTemplateTextArea'
                          )
                        "
                        >Link</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-textarea
                      id="emailTemplateTextArea"
                      v-model="templateForm.emailTemplate"
                      name="input-7-1"
                      class="ma-0 pa-0"
                      filled
                      label="Email template"
                      :rules="[rules.required]"
                      auto-grow
                    ></v-textarea>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_name',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_fullname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_firstname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_surname',
                            'smsTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_date',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_start_time',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_end_time',
                            'smsTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_room_name',
                            'smsTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >sms</v-icon
                    >
                    <v-textarea
                      id="smsTemplateTextArea"
                      v-model="templateForm.smsTemplate"
                      name="input-7-1"
                      filled
                      label="SMS template"
                      counter="160"
                      :rules="[rules.required]"
                      auto-grow
                    ></v-textarea>
                    <v-file-input
                      multiple
                      label="Upload informed consent"
                      v-model="templateForm.attachment"
                    ></v-file-input>
                    <v-chip
                      class="mr-2"
                      close
                      color="primary"
                      align="right"
                      v-for="template in templateForm.attachmentChips"
                      :key="template.id"
                      @click:close="deleteTemplateAttachment(template.id)"
                    >
                      <v-icon left>mdi-file-document</v-icon>
                      {{ template.name }}
                    </v-chip>
                  </v-card-text>
                </v-tab-item>
                <v-tab-item>
                  <v-card-text>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-text-field
                      v-model="templateForm.reminderEmailSubject"
                      label="Email reminder subject"
                      filled
                    ></v-text-field>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_name',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_fullname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_firstname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'user_surname',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_details_table',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event details table</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_date',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_start_time',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_end_time',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToEmailTemplate(
                            'event_room_name',
                            'emailReminderTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >email</v-icon
                    >
                    <v-textarea
                      id="emailReminderTemplateTextArea"
                      v-model="templateForm.reminderEmailTemplate"
                      name="input-7-1"
                      class="ma-0 pa-0"
                      filled
                      label="Email reminder template"
                      auto-grow
                    ></v-textarea>
                    <div class="ml-8">
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_name',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_fullname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's full name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_firstname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's first name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'user_surname',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >User's last name</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_date',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event date</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_start_time',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event start time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_end_time',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Event end time</v-btn
                      >
                      <v-btn
                        class="ma-1"
                        outlined
                        color="indigo"
                        x-small
                        @click="
                          addTextToSMSTemplate(
                            'event_room_name',
                            'smsReminderTemplateTextArea'
                          )
                        "
                        >Room name</v-btn
                      >
                    </div>
                    <v-icon class="float-left py-4 pr-2" color="primary"
                      >sms</v-icon
                    >
                    <v-textarea
                      id="smsReminderTemplateTextArea"
                      v-model="templateForm.smsReminderTemplate"
                      name="input-7-1"
                      filled
                      label="SMS reminder template"
                      counter="160"
                      auto-grow
                    ></v-textarea>
                    <v-file-input
                      multiple
                      label="Upload document"
                      v-model="templateForm.reminderAttachment"
                    ></v-file-input>
                    <v-chip
                      class="mr-2"
                      close
                      color="primary"
                      align="right"
                      v-for="template in templateForm.reminderAttachmentChips"
                      :key="template.id"
                      @click:close="
                        deleteTemplateReminderAttachment(template.id)
                      "
                    >
                      <v-icon left>mdi-file-document</v-icon>
                      {{ template.name }}
                    </v-chip>
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>

              <v-card-actions>
                <v-btn
                  color="info"
                  :right="true"
                  @click="updateCommsTemplateDialog = false"
                  class="hp--btn"
                  >Close</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :right="true"
                  :loading="updateCommsTemplateLoader"
                  @click="updateCommsTemplate"
                  class="hp--btn"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>

      <v-card class="mx-auto" max-width="1000">
        <v-toolbar flat>
          <v-toolbar-title class="grey--text">Templates</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <div class="flex-grow-1"></div>
          <v-text-field
            class="mt-7"
            v-model="search"
            label="Search"
            required
            append-icon="search"
          ></v-text-field>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mb-1 hp--btn"
                color="primary"
                dark
                small
                absolute
                bottom
                left
                fab
                v-on="on"
                @click="
                  templateForm = {
                    emailTemplate: ``,
                    smsTemplate: ``,
                    reminderEmailTemplate: ``,
                    smsReminderTemplate: ``,
                    reminderEmailSubject: ``,
                  };
                  createCommsTemplateDialog = !createCommsTemplateDialog;
                "
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>New template</span>
          </v-tooltip>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text>
          <v-card flat v-for="template in filteredData" :key="template.id">
            <v-layout :class="`pa-3 ${template.id}`">
              <v-flex xs12 sm2 lg2>
                <div class="caption grey--text">Name</div>
                <div>{{ template.name }}</div>
              </v-flex>
              <v-flex xs12 md2 lg2>
                <div class="caption grey--text">Email</div>
                <div class="text-truncate">{{ template.emailTemplate }}</div>
              </v-flex>
              <v-flex xs12 sm2 lg2>
                <div class="caption grey--text">SMS</div>
                <div class="text-truncate">{{ template.smsTemplate }}</div>
              </v-flex>
              <v-flex xs12 md2 lg2>
                <div class="caption grey--text">Email reminder</div>
                <div class="text-truncate">
                  {{ template.reminderEmailTemplate }}
                </div>
              </v-flex>
              <v-flex xs12 sm2 lg2>
                <div class="caption grey--text">SMS reminder</div>
                <div class="text-truncate">
                  {{ template.smsReminderTemplate }}
                </div>
              </v-flex>
              <v-flex xs12 sm2 lg2>
                <div class="float-right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-2 hp--btn"
                        fab
                        dark
                        small
                        color="success"
                        @click="onCommsTemplateUpdate(template)"
                      >
                        <v-icon v-on="on" dark>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Update template</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="mx-2 hp--btn"
                        fab
                        dark
                        small
                        color="error"
                        @click="deleteCommsTemplate(template)"
                      >
                        <v-icon v-on="on" dark>delete_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete template</span>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { Storage } from "aws-amplify";
import Header from "../components/Header.vue";
import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "./../graphql/mutations";
import { s3helper } from "../classes/s3helper";
import _ from "lodash";

export default {
  components: {
    Header,
  },
  data() {
    return {
      templates: [],
      nextToken: null,
      createCommsTemplateDialog: false,
      updateCommsTemplateDialog: false,
      createCommsTemplateLoader: false,
      updateCommsTemplateLoader: false,
      rules: {
        required: (v) => !!v || "This field is required.",
      },
      templateForm: {
        emailTemplate: `Hi [user_firstname]

Please see your booking reminder below: 

[event_details_table] 

Please remember to bring your completed 7 day sleep diary to the session.

Please aim to arrive 5 minutes prior to the start time to ensure we can begin promptly. 

If you have any questions please contact the HP Team on 0800 170 1777 or email us team@healthyperformance.co.uk`,
        reminderEmailTemplate: "",
        smsTemplate: `Hi [user_firstname] remember you've booked a place on the forthcoming workshop which is taking place at [event_start_time] in [event_room_name] on [event_date]. Please call 0800 170 1777 if you have any questions.`,
        smsReminderTemplate: "",
      },
      tab: 0,
      search: "",
    };
  },
  methods: {
    createNewCommsTemplate() {
      if (this.$refs.formCreateTemplate.validate()) {
        const that = this;
        that.createCommsTemplateLoader = true;
        const createEventCommsTemplate = `mutation CreateEventCommsTemplate(
          $input: CreateEventCommsTemplateInput!
          $condition: ModelEventCommsTemplateConditionInput
        ) {
          createEventCommsTemplate(input: $input, condition: $condition) {
            id
            name
            emailSubject
            reminderEmailSubject
            emailTemplate
            smsTemplate
            reminderEmailTemplate
            smsReminderTemplate
            eventCommsTemplateAttachments {
              items {
                id
                attachment
                isDeleted
              }
            }
            isDeleted
          }
        }
        `;

        let input = {
          name: that.templateForm.name,
          emailSubject: that.templateForm.subject,
          emailTemplate: that.templateForm.emailTemplate, //.replace(/\n/g, "<br/>"),
          smsTemplate: that.templateForm.smsTemplate,
          isDeleted: 0,
        };
        if (that.templateForm.reminderEmailTemplate) {
          input.reminderEmailTemplate = that.templateForm.reminderEmailTemplate; //.replace(/\n/g, "<br/>");
        }
        if (that.templateForm.smsReminderTemplate) {
          input.smsReminderTemplate = that.templateForm.smsReminderTemplate;
        }
        if (that.templateForm.reminderEmailSubject) {
          input.reminderEmailSubject = that.templateForm.reminderEmailSubject;
        }

        API.graphql(
          graphqlOperation(createEventCommsTemplate, {
            input,
          })
        ).then((result) => {
          const commsTemplate = result.data.createEventCommsTemplate;
          that.templates.push({
            id: commsTemplate.id,
            name: commsTemplate.name,
            emailSubject: commsTemplate.subject,
            reminderEmailSubject: commsTemplate.reminderEmailSubject,
            emailTemplate: commsTemplate.emailTemplate,
            reminderEmailTemplate: commsTemplate.reminderEmailTemplate,
            smsReminderTemplate: commsTemplate.smsReminderTemplate,
            smsTemplate: commsTemplate.smsTemplate,

            eventCommsTemplateAttachments:
              commsTemplate.eventCommsTemplateAttachments,
          });
          that.templates = _.orderBy(that.templates, "name", "asc");
          if (
            that.templateForm.attachment ||
            that.templateForm.reminderAttachment
          ) {
            let i = 0;
            if (this.templateForm.attachment) {
              that.templateForm.attachment.forEach(function (attachment) {
                const fileName = attachment.name;
                const s3Key = s3helper.generateS3Key(fileName);
                Storage.put(
                  "healthyevents/commstemplate/" + s3Key,
                  attachment,
                  {
                    level: "public",
                    contentType: attachment.type,
                  }
                ).then((attachmentResult) => {
                  API.graphql(
                    graphqlOperation(
                      mutations.createEventCommsTemplateAttachments,
                      {
                        input: {
                          key: attachmentResult.key,
                          name: fileName,
                          attachment: "booking",
                          isDeleted: 0,
                          eventCommsTemplateAttachmentsEventCommsTemplateId:
                            commsTemplate.id,
                        },
                      }
                    )
                  ).then((templateAttachmentResult) => {
                    const eventCommsTemplateAttachment =
                      templateAttachmentResult.data
                        .createEventCommsTemplateAttachments;

                    let index = that.templates.findIndex(
                      (template) => template.id === commsTemplate.id
                    );

                    that.templates[
                      index
                    ].eventCommsTemplateAttachments.items.push({
                      id: attachment.id,
                      key: attachment.key,
                      attachment: attachment.attachment,
                      name: attachment.name,
                      isDeleted: attachment.isDeleted,
                    });
                    i++;
                    if (i === that.templateForm.attachment.length) {
                      that.createCommsTemplateLoader = false;
                      that.createCommsTemplateDialog = false;
                    }
                  });
                });
              });
            }

            if (this.templateForm.reminderAttachment) {
              that.templateForm.reminderAttachment.forEach(function (
                attachment
              ) {
                const fileName = attachment.name;
                const s3Key = s3helper.generateS3Key(fileName);
                Storage.put(
                  "healthyevents/commstemplate/" + s3Key,
                  attachment,
                  {
                    level: "public",
                    contentType: attachment.type,
                  }
                ).then((attachmentResult) => {
                  API.graphql(
                    graphqlOperation(
                      mutations.createEventCommsTemplateAttachments,
                      {
                        input: {
                          key: attachmentResult.key,
                          attachment: "reminder",
                          name: fileName,
                          isDeleted: 0,
                          eventCommsTemplateAttachmentsEventCommsTemplateId:
                            commsTemplate.id,
                        },
                      }
                    )
                  ).then((templateAttachmentResult) => {
                    const eventCommsTemplateAttachment =
                      templateAttachmentResult.data
                        .createEventCommsTemplateAttachments;

                    let index = that.templates.findIndex(
                      (template) => template.id === commsTemplate.id
                    );

                    that.templates[
                      index
                    ].eventCommsTemplateAttachments.items.push({
                      id: attachment.id,
                      key: attachment.key,
                      attachment: attachment.attachment,
                      name: attachment.name,
                      isDeleted: attachment.isDeleted,
                    });
                    i++;
                    if (i === that.templateForm.reminderAttachment.length) {
                      that.createCommsTemplateLoader = false;
                      that.createCommsTemplateDialog = false;
                    }
                  });
                });
              });
            } else {
              that.createCommsTemplateLoader = false;
              that.createCommsTemplateDialog = false;
            }
          }
          that.createCommsTemplateLoader = false;
          that.createCommsTemplateDialog = false;
        });
      }
    },
    updateCommsTemplate() {
      if (this.$refs.formUpdateCreateTemplate.validate()) {
        const that = this;
        that.updateCommsTemplateLoader = true;
        if (
          this.templateForm.attachment ||
          this.templateForm.reminderAttachment
        ) {
          const updateEventCommsTemplate = `mutation UpdateEventCommsTemplate(
            $input: UpdateEventCommsTemplateInput!
            $condition: ModelEventCommsTemplateConditionInput
          ) {
            updateEventCommsTemplate(input: $input, condition: $condition) {
              id
              name
              emailSubject
              reminderEmailSubject
              emailTemplate
              smsTemplate
              reminderEmailTemplate
              smsReminderTemplate
              eventCommsTemplateAttachments {
                items {
                  id
                  key
                  name
                  attachment
                  isDeleted
                }
              }
              isDeleted
            }
          }
          `;
          API.graphql(
            graphqlOperation(updateEventCommsTemplate, {
              input: {
                id: this.templateForm.id,
                name: this.templateForm.name,
                emailSubject: this.templateForm.subject,
                reminderEmailSubject: this.templateForm.reminderEmailSubject,
                emailTemplate: this.templateForm.emailTemplate,
                smsTemplate: this.templateForm.smsTemplate,
                reminderEmailTemplate: this.templateForm.reminderEmailTemplate,
                smsReminderTemplate: this.templateForm.smsReminderTemplate,
              },
            })
          ).then((result) => {
            let eventCommsTemplateId = result.data.updateEventCommsTemplate.id;
            let eventCommsTemplate = result.data.updateEventCommsTemplate;

            let index = that.templates.findIndex(
              (template) => template.id === eventCommsTemplateId
            );

            that.templates[index] = {
              id: eventCommsTemplate.id,
              name: eventCommsTemplate.name,
              emailSubject: eventCommsTemplate.subject,
              reminderEmailSubject: eventCommsTemplate.reminderEmailSubject,
              emailTemplate: eventCommsTemplate.emailTemplate,
              smsTemplate: eventCommsTemplate.smsTemplate,
              reminderEmailTemplate: eventCommsTemplate.reminderEmailTemplate,
              smsReminderTemplate: eventCommsTemplate.smsReminderTemplate,
              eventCommsTemplateAttachments:
                eventCommsTemplate.eventCommsTemplateAttachments,
            };

            if (this.templateForm.attachment) {
              this.templateForm.attachment.forEach(function (attachment) {
                const fileName = attachment.name;
                const s3Key = s3helper.generateS3Key(fileName);
                Storage.put(
                  "healthyevents/commstemplate/" + s3Key,
                  attachment,
                  {
                    level: "public",
                    contentType: attachment.type,
                  }
                ).then((attachmentResult) => {
                  API.graphql(
                    graphqlOperation(
                      mutations.createEventCommsTemplateAttachments,
                      {
                        input: {
                          key: attachmentResult.key,
                          attachment: "booking",
                          name: fileName,
                          isDeleted: 0,
                          eventCommsTemplateAttachmentsEventCommsTemplateId:
                            eventCommsTemplateId,
                        },
                      }
                    )
                  ).then((templateAttachmentResult) => {
                    const eventCommsTemplateAttachment =
                      templateAttachmentResult.data
                        .createEventCommsTemplateAttachments;

                    that.templates[
                      index
                    ].eventCommsTemplateAttachments.items.push({
                      id: eventCommsTemplateAttachment.id,
                      key: eventCommsTemplateAttachment.key,
                      name: eventCommsTemplateAttachment.name,
                      attachment: "booking",
                      isDeleted: eventCommsTemplateAttachment.isDeleted,
                    });
                    that.updateCommsTemplateLoader = false;
                    that.updateCommsTemplateDialog = false;
                  });
                });
              });
            }

            if (this.templateForm.reminderAttachment) {
              this.templateForm.reminderAttachment.forEach(function (
                attachment
              ) {
                const fileName = attachment.name;
                const s3Key = s3helper.generateS3Key(fileName);
                Storage.put(
                  "healthyevents/commstemplate/" + s3Key,
                  attachment,
                  {
                    level: "public",
                    contentType: attachment.type,
                  }
                ).then((attachmentResult) => {
                  API.graphql(
                    graphqlOperation(
                      mutations.createEventCommsTemplateAttachments,
                      {
                        input: {
                          key: attachmentResult.key,
                          attachment: "reminder",
                          name: fileName,
                          isDeleted: 0,
                          eventCommsTemplateAttachmentsEventCommsTemplateId:
                            eventCommsTemplateId,
                        },
                      }
                    )
                  ).then((templateAttachmentResult) => {
                    const eventCommsTemplateAttachment =
                      templateAttachmentResult.data
                        .createEventCommsTemplateAttachments;

                    that.templates[
                      index
                    ].eventCommsTemplateAttachments.items.push({
                      id: eventCommsTemplateAttachment.id,
                      key: eventCommsTemplateAttachment.key,
                      name: eventCommsTemplateAttachment.name,
                      isDeleted: eventCommsTemplateAttachment.isDeleted,
                    });
                    that.updateCommsTemplateLoader = false;
                    that.updateCommsTemplateDialog = false;
                  });
                });
              });
            }
          });
        } else {
          API.graphql(
            graphqlOperation(mutations.updateEventCommsTemplate, {
              input: {
                id: this.templateForm.id,
                name: this.templateForm.name,
                emailSubject: this.templateForm.subject,
                reminderEmailSubject: this.templateForm.reminderEmailSubject,
                emailTemplate: this.templateForm.emailTemplate,
                smsTemplate: this.templateForm.smsTemplate,
                reminderEmailTemplate: this.templateForm.reminderEmailTemplate,
                smsReminderTemplate: this.templateForm.smsReminderTemplate,
              },
            })
          ).then((result) => {
            const eventCommsTemplate = result.data.updateEventCommsTemplate;
            const index = this.templates.findIndex(
              (template) => template.id === eventCommsTemplate.id
            );
            this.templates[index] = {
              id: eventCommsTemplate.id,
              name: eventCommsTemplate.name,
              emailSubject: eventCommsTemplate.subject,
              reminderEmailSubject: eventCommsTemplate.reminderEmailSubject,
              emailTemplate: eventCommsTemplate.emailTemplate,
              smsTemplate: eventCommsTemplate.smsTemplate,
              reminderEmailTemplate: eventCommsTemplate.reminderEmailTemplate,
              smsReminderTemplate: eventCommsTemplate.smsReminderTemplate,
              eventCommsTemplateAttachments:
                eventCommsTemplate.eventCommsTemplateAttachments,
            };
            that.updateCommsTemplateLoader = false;
            that.updateCommsTemplateDialog = false;
          });
        }
      }
    },
    deleteTemplateAttachment(templateId) {
      if (confirm("Are you sure you want to delete template attachment?")) {
        API.graphql(
          graphqlOperation(mutations.deleteEventCommsTemplateAttachments, {
            input: {
              id: templateId,
            },
          })
        ).then(() => {
          this.templateForm.attachmentChips =
            this.templateForm.attachmentChips.filter((attachment) => {
              return attachment.id !== templateId;
            });
        });
      }
    },
    deleteTemplateReminderAttachment(templateId) {
      if (
        confirm("Are you sure you want to delete template reminder attachment?")
      ) {
        API.graphql(
          graphqlOperation(mutations.deleteEventCommsTemplateAttachments, {
            input: {
              id: templateId,
            },
          })
        ).then(() => {
          this.templateForm.reminderAttachmentChips =
            this.templateForm.reminderAttachmentChips.filter((attachment) => {
              return attachment.id !== templateId;
            });
        });
      }
    },
    deleteCommsTemplate(template) {
      if (confirm("Are you sure you want to delete this template?")) {
        API.graphql(
          graphqlOperation(mutations.updateEventCommsTemplate, {
            input: {
              id: template.id,
              isDeleted: 1,
            },
          })
        ).then((result) => {
          const index = this.templates.findIndex(
            (template) =>
              template.id === result.data.updateEventCommsTemplate.id
          );
          this.templates.splice(index, 1);
        });
      }
    },
    onCommsTemplateUpdate(template) {
      const getEventCommsTemplate = `query GetEventCommsTemplate($id: ID!) {
        getEventCommsTemplate(id: $id) {
          id
          name
          emailSubject
          reminderEmailSubject
          emailTemplate
          smsTemplate
          reminderEmailTemplate
          smsReminderTemplate
          eventCommsTemplateAttachments {
            items {
              id
              attachment
              key
              name
              isDeleted
            }
          }
          isDeleted
        }
      }
      `;
      API.graphql(
        graphqlOperation(getEventCommsTemplate, {
          id: template.id,
        })
      ).then((result) => {
        const getEventCommsTemplate = result.data.getEventCommsTemplate;
        this.templateForm = {
          id: getEventCommsTemplate.id,
          name: getEventCommsTemplate.name,
          subject: getEventCommsTemplate.emailSubject,
          reminderEmailSubject: getEventCommsTemplate.reminderEmailSubject,
          emailTemplate: getEventCommsTemplate.emailTemplate,
          smsTemplate: getEventCommsTemplate.smsTemplate,
          reminderEmailTemplate: getEventCommsTemplate.reminderEmailTemplate,
          smsReminderTemplate: getEventCommsTemplate.smsReminderTemplate,
          attachmentChips:
            getEventCommsTemplate.eventCommsTemplateAttachments.items.filter(
              (attach) => attach.attachment === "booking"
            ),
          reminderAttachmentChips:
            getEventCommsTemplate.eventCommsTemplateAttachments.items.filter(
              (attach) => attach.attachment === "reminder"
            ),
        };
        this.updateCommsTemplateDialog = true;
      });
    },
    addTextToEmailTemplate(text, elementId) {
      const that = this;
      const cursorIndex = document.getElementById(elementId).selectionEnd;
      if (elementId === "emailReminderTemplateTextArea") {
        const textBefore = this.templateForm.reminderEmailTemplate.substring(
          0,
          cursorIndex
        );
        const textAfter = this.templateForm.reminderEmailTemplate.substring(
          cursorIndex,
          this.templateForm.reminderEmailTemplate.length
        );
        this.templateForm.reminderEmailTemplate =
          textBefore + "[" + text + "] " + textAfter;
      } else {
        const textBefore = that.templateForm.emailTemplate.substring(
          0,
          cursorIndex
        );
        const textAfter = that.templateForm.emailTemplate.substring(
          cursorIndex,
          that.templateForm.emailTemplate.length
        );
        that.templateForm.emailTemplate =
          textBefore + "[" + text + "] " + textAfter;
      }
    },
    addTextToSMSTemplate(text, elementId) {
      const cursorIndex = document.getElementById(elementId).selectionEnd;
      if (elementId === "smsReminderTemplateTextArea") {
        const textBefore = this.templateForm.smsReminderTemplate.substring(
          0,
          cursorIndex
        );
        const textAfter = this.templateForm.smsReminderTemplate.substring(
          cursorIndex,
          this.templateForm.smsReminderTemplate.length
        );
        this.templateForm.smsReminderTemplate =
          textBefore + "[" + text + "] " + textAfter;
      } else {
        const textBefore = this.templateForm.smsTemplate.substring(
          0,
          cursorIndex
        );
        const textAfter = this.templateForm.smsTemplate.substring(
          cursorIndex,
          this.templateForm.smsTemplate.length
        );

        this.templateForm.smsTemplate =
          textBefore + "[" + text + "] " + textAfter;
      }
    },
    deleteAttachment(id, fileName) {
      if (id) {
        API.graphql(
          graphqlOperation(mutations.deleteEventCommsTemplateAttachments, {
            input: {
              id: id,
            },
          })
        ).then((result) => {
          const index = this.templateForm.attachmentChips.findIndex(
            (template) => template.id === id
          );
          this.templateForm.attachmentChips.splice(index, 1);
        });
      }
    },
    async nextRecord() {
      const listEventCommsTemplates = /* GraphQL */ `
        query ListEventCommsTemplates(
          $filter: ModelEventCommsTemplateFilterInput
          $limit: Int
          $nextToken: String
        ) {
          listEventCommsTemplates(
            filter: $filter
            limit: $limit
            nextToken: $nextToken
          ) {
            items {
              id
              name
              emailSubject
              reminderEmailSubject
              emailTemplate
              smsTemplate
              reminderEmailTemplate
              smsReminderTemplate
              isDeleted
              eventCommsTemplateAttachments {
                items {
                  id
                  attachment
                  isDeleted
                }
              }
            }
            nextToken
          }
        }
      `;

      const {
        data: {
          listEventCommsTemplates: { items: templates },
        },
        data: {
          listEventCommsTemplates: { nextToken: token },
        }
      } = await API.graphql({
        query: listEventCommsTemplates,
        variables: {
          filter: { isDeleted: { eq: 0 } },
          nextToken: this.nextToken
        }
      });
      let templatesResults = [];
      this.nextToken = token;
      templates.forEach(function (template) {
        if (template.isDeleted === 0) {
          templatesResults.push({
            id: template.id,
            name: template.name,
            emailSubject: template.emailSubject,
            reminderEmailSubject: template.reminderEmailSubject,
            emailTemplate: template.emailTemplate,
            smsTemplate: template.smsTemplate,
            reminderEmailTemplate: template.reminderEmailTemplate,
            smsReminderTemplate: template.smsReminderTemplate,
            attachmentChips:
              template.eventCommsTemplateAttachments.items.filter(
                (attach) => attach.attachment === "booking"
              ),
            reminderAttachmentChips:
              template.eventCommsTemplateAttachments.items.filter(
                (attach) => attach.attachment === "reminder"
              ),
          });
        }
      });
      return templatesResults;
    }
  },
  async created() {
    const that = this;
    let templates = await this.nextRecord();

    while (this.nextToken !== null) {
      let nextTemplate = await this.nextRecord();
      templates.push(...nextTemplate);
    }
    that.templates = _.orderBy(templates, "name", "asc");
  },
  computed: {
    filteredData() {
      if (this.search) {
        return this.templates.filter(
          (template) =>
            template.name &&
            template.name.toLowerCase().indexOf(this.search.toLowerCase()) != -1
        );
      }
      return this.templates;
    },
  },
};
</script>
